export const ServerSettingsActionCreators = {
  set: (settings) => ({
    type: "SET_SERVER_SETTINGS",
    payload: settings,
  }),
};
